import { render, staticRenderFns } from "./link-list-component.vue?vue&type=template&id=493c59a4&scoped=true"
import script from "./link-list-component.ts?vue&type=script&lang=ts&external"
export * from "./link-list-component.ts?vue&type=script&lang=ts&external"
import style0 from "./link-list-component.scss?vue&type=style&index=0&id=493c59a4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c59a4",
  null
  
)

export default component.exports